import hospitalServices from '@/api/hospital.js'
import orderServices from '@/api/order.js'
import { getAddress } from '@/api/user.js'
import moduleServices from '@/api/moduleManage.js'
import btnServices from '@/api/btnManage.js'
import feedbackServices from '@/api/feedback.js'

const services = {
    user: {
        getAddress: getAddress
    },
    hospital: hospitalServices,
    order: orderServices,
    moduleServices: moduleServices,
    btnServices: btnServices,
    feedbackServices: feedbackServices
}

export default services
